<template>
    <div id="app">
        <div class="chart-data" >
            <div class="ctx-top">
                <div class="title">总学习时长</div>
                <div class="time">{{studyInfos.studyHours}}<span>小时</span></div>
            </div>
            <div class="ctx-warp" id="ctxWarp">
                <canvas id="ctx"></canvas>
            </div>
        </div>
        <ul class="data-lists">
<!--           <li class="list-item">-->
<!--               <div class="item_left">课程学习时长</div>-->
<!--               <div class="item_right">-->
<!--                   <span class="r_data">{{studyInfos.todayMinutes}}</span>-->
<!--                   <span class="r_unit">分钟</span>-->
<!--               </div>-->
<!--           </li>-->
            <li class="list-item">
                <div class="item_left">习题练习数量</div>
                <div class="item_right">
                    <span class="r_data">{{studyInfos.userLearningQuestionAnswerRecordCount}}</span>
                    <span class="r_unit">题</span>
                </div>
            </li>
            <li class="list-item">
                <div class="item_left">连续学习天数</div>
                <div class="item_right">
                    <span class="r_data">{{studyInfos.continuousLearningDays}}</span>
                    <span class="r_unit">天</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Chart from 'chart.js';
    import { getUserCourseStatistics } from '@/api/userNurse.js';
    import {fillerLeft} from "@/utils";
    import {dataBuryingPoint} from '@/utils/JSBridge.js'
    export default {
        name: 'app',
        data: function () {
            return {
                studyInfos: {
                    studyHours: 0, // 总学习时长（单位小时）
                    continuousLearningDays: 0, // 连续学习天数（单位天）
                    todayMinutes: 0, // 今日学习分钟数（单位分钟）
                    userLearningQuestionAnswerRecordCount: 0, //习题练习数量
                }
            }
        },
        methods: {
            drawCanvas(labels, studyData) {
                let ctxWarp = document.getElementById('ctxWarp');
                let ctx = document.getElementById('ctx');
                ctx.style.width = ctxWarp.offsetWidth+'px';
                ctx.style.height = ctxWarp.offsetHeight+'px';

                var myChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: '0.5',
                            data: studyData,
                            backgroundColor:'#fff',
                            borderColor:'#F84025',
                            pointStrokeWidth:5
                        }]
                    },
                    options: {
                        hover: {
                            animationDuration: 0  // 防止鼠标移上去，数字闪烁
                        },
                        animation: {
                            // 这部分是数值显示的功能实现
                            onComplete: function () {
                                var chartInstance = this.chart,
                                    ctx = chartInstance.ctx;
                                ctx.fillStyle = "#A6A7A7";
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';
                                this.data.datasets.forEach(function (dataset, i) {
                                    let meta = chartInstance.controller.getDatasetMeta(i);
                                    meta.data.forEach(function (bar, index) {
                                        let data = dataset.data[index];
                                        ctx.fillText(data+'分', bar._model.x, bar._model.y - 14);
                                    });
                                });
                            }
                        },
                        legend:{
                            display: false
                        },
                        tooltips:{
                            enabled:false,
                        },
                        scales: {
                            yAxes: [
                                {
                                    display: false
                                }
                            ],
                            xAxes:[
                                {
                                    gridLines:{
                                        display: false
                                    },
                                    ticks:{
                                        fontColor:'#A6A7A7'
                                    }
                                }
                            ]
                        },
                        layout: {
                            padding: {
                                left: 26,
                                right: 26,
                                top: 26,
                                bottom: 10
                            }
                        },
                        elements:{
                            point:{
                                radius:6,
                                borderWidth:2
                            },
                            line:{
                                tension:0,
                                borderWidth:1.5
                            }
                        },
                    }
                });

            }

        },
        mounted() {
            getUserCourseStatistics().then(r => {
                fillerLeft(this.studyInfos, r);
                let recentData = r.studyDurationByDayList;
                let dayList = recentData.map(v => v.datePattern.substr(5).replace('-', '.'));
                let minutesList = recentData.map(v => v.studyMinutes);
                this.drawCanvas(dayList, minutesList);
            }).catch(_ => {});
            dataBuryingPoint('F000009', 'F000009-001');
        },
        beforeDestroy: function () {

        },
        components: {}
    }
</script>
<style lang="scss" scoped>
#app {
    background: #2E384D;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    padding: 15px 16px 0;
    .chart-data {
        height:235px;
        position: relative;
        display: flex;
        flex-direction: column;
        background:rgba(255,255,255,1);
        .ctx-top{
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 62px;
            padding: 0 14px;
            align-items: center;
            .title{
                font-weight: bold;
                color: #141A1B;
                font-size: 19px;
            }
            .time{
                color: #F84025;
                font-size: 19px;
                span{
                    color: #A6A7A7;
                    font-size: 11px;
                }
            }
        }
        .ctx-warp{
            width: 100%;
            flex: 1;
        }
    }
    .data-lists {
        margin-top: 16px;
        background:rgba(60,73,99,.6);
        list-style-type:circle;
        .list-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 54px;
            padding-left: 13px;
            padding-right: 26px;
            border-bottom: 1px solid #2f3d58;
            &:last-child {
                border-bottom: none;
            }
            .item_left {
                font-size:15px;
                color:rgba(255,255,255,1);
            }
            .item_right {
                font-size:11px;
                color:rgba(255,255,255,1);
                .r_data {
                    font-size:14px;
                    color:rgba(255,255,245,1);
                    padding-right: 2px;
                }
                .r_unit {
                    font-size:11px;
                    color:rgba(255,255,255,1);
                    opacity:0.5;
                }

            }
        }
    }
}
</style>
